/**
 * "Maak de routine compleet": gerelateerde producten.
 * CRM-veld `past_bij` (lijst van SKU's) heeft voorrang; anders de vaste combinaties uit de briefing
 * en als laatste redmiddel: dezelfde categorie (borstel-trio, rager-maten).
 */
const FRANKLY_PAREN = [["FR1009", "FR1001"], ["FR1004", "FR1003"], ["FR1005", "FR1006"]];

const skuLijst = (waarde) => {
  if (Array.isArray(waarde)) return waarde.map((x) => String(x).trim().toUpperCase()).filter(Boolean);
  return String(waarde || "").split(/[,;\s]+/).map((x) => x.trim().toUpperCase()).filter(Boolean);
};

const hoofdproduct = (p) => !(p?.parent_sku || p?.parent_id);

export function pastBij(product, alle = [], max = 4) {
  if (!product) return [];
  const sku = String(product.sku || "").toUpperCase();
  const perSku = new Map(alle.filter(hoofdproduct).map((p) => [String(p.sku || "").toUpperCase(), p]));

  const uitCrm = skuLijst(product.past_bij).map((s) => perSku.get(s)).filter(Boolean);
  if (uitCrm.length) return uitCrm.slice(0, max);

  const paar = FRANKLY_PAREN.find((p) => p.includes(sku));
  if (paar) {
    const ander = perSku.get(paar.find((s) => s !== sku));
    if (ander) return [ander];
  }

  const cat = (product.webshop_categorie || "").trim().toLowerCase();
  const merk = (product.merk || "").trim().toLowerCase();
  if (!cat) return [];
  return alle
    .filter(hoofdproduct)
    .filter((p) => p.id !== product.id && (p.webshop_categorie || "").trim().toLowerCase() === cat && (p.merk || "").trim().toLowerCase() === merk)
    .slice(0, max);
}
